/**
 * @internal
 */
/**
 * Clamp a value between a min and max
 */
export const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
/**
 * Maps % position to value
 */
export const percentageToValue = (value, min, max) => {
    const range = max - min;
    return clamp(value * range + min, min, max);
};
/**
 * Maps value to % position
 */
export const valueToPercentage = (value, min, max) => {
    const range = max - min;
    return clamp(1 / (range / (value - min)), 0, 1) || 0;
};
/**
 * Get closest number in array
 */
export const getClosest = (array, x) => array.sort((a, b) => Math.abs(x - a) - Math.abs(x - b))[0];
/**
 * Will cut-off the number precision to a certain amount of digits to ensure no floating point rounding errors break the output.
 * There is no rounding done.
 *
 * So move 0.02 (digits 1) to '0.2' (multiplied) to 0 (cut-off).
 */
export const toPrecision = (value, digits) => {
    let stringValue = value.toString();
    // check if a scientific notation is used like 1e-9 or 1e21
    const scientificNotation = stringValue.indexOf('e');
    const charAfterScientificNotation = stringValue.charAt(scientificNotation + 1);
    if (scientificNotation > -1) {
        const isNegative = stringValue.charAt(0) === '-';
        const prefix = stringValue.charAt(0) === '-' ? '-' : '';
        stringValue =
            charAfterScientificNotation === '-'
                ? `${prefix}0.${'0'.repeat(Number(stringValue.slice(scientificNotation + 2)) - 1)}${stringValue.slice(isNegative ? 1 : 0, scientificNotation).replace('.', '')}`
                : `${stringValue.slice(0, scientificNotation)}${'0'.repeat(Number(stringValue.slice(scientificNotation + 2)))}`;
    }
    const dot = stringValue.indexOf('.');
    return Number(stringValue.slice(0, (dot > -1 ? dot : stringValue.length) + digits + 1));
};
